export const SUPPORT_WORKSPACE_PATH = '/admin/support';
export const ALL_TENANTS = 'all';
export const SUPPORT_TABS = ['overview', 'support', 'billing', 'data-usage', 'configuration'];
export const ALL_TENANT_SUPPORT_CAP = 8;

export function normalizeSupportTab(tab) {
  const value = tab === 'usage' ? 'data-usage' : String(tab || 'overview');
  return SUPPORT_TABS.includes(value) ? value : 'overview';
}

export function supportNavTarget(role) {
  return role === 'superadmin' ? SUPPORT_WORKSPACE_PATH : '/support/reports';
}

export function parseSupportLocation(searchParams) {
  const tenantId = String(searchParams.get('tenantId') || ALL_TENANTS).trim() || ALL_TENANTS;
  const tab = normalizeSupportTab(searchParams.get('tab'));
  const month = String(searchParams.get('month') || '');
  return { tenantId, tab, month };
}

export function supportSearch({ tenantId = ALL_TENANTS, tab = 'overview', month = '' } = {}) {
  const params = new URLSearchParams();
  params.set('tenantId', tenantId || ALL_TENANTS);
  params.set('tab', normalizeSupportTab(tab));
  if (/^\d{4}-(0[1-9]|1[0-2])$/.test(month)) params.set('month', month);
  return params;
}

export function supportPath(options) {
  return `${SUPPORT_WORKSPACE_PATH}?${supportSearch(options).toString()}`;
}

export function tenantDetailsHref(tenantId) {
  return supportPath({ tenantId, tab: 'overview' });
}

export function tenantStatusLabel(tenant) {
  if (!tenant) return 'Unknown';
  if (tenant.tombstone === true || tenant.deletionStatus === 'deleted') return 'Deleted';
  if (tenant.deletionLock || tenant.deletionStatus === 'deleting') return 'Deleting';
  if (tenant.active === false) return 'Inactive';
  return 'Active';
}
